import { PostAdd as PostAddIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

interface NewChatButtonProps {
  onClick: () => void;
}

export const NewChatButton: React.FC<NewChatButtonProps> = ({ onClick }) => {
  return (
    <Tooltip title="Start new chat" placement="right" arrow>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          backgroundColor: "background.paper",
          border: 1,
          borderColor: "divider",
          opacity: 0.75,
          "&:hover": {
            backgroundColor: "action.hover",
            opacity: 1,
          },
        }}
      >
        <PostAddIcon />
      </IconButton>
    </Tooltip>
  );
};
